import { createContext } from "react";
const adminContext = createContext<any>({});
export default adminContext;
